module.exports = __webpack_public_path__ + "img/crown_rewards_white.11aeece4.svg";